module.exports = __webpack_public_path__ + "static/img/echart7.e0cd0b85.png";